export default __webpack_public_path__ + "static/media/naan.bdd0bf14.jpg";